export const LANGUAGES = [
    { value: 'EN', label: 'English' },
    { value: 'FR', label: 'French' },
    { value: 'DE', label: 'German' },
    { value: 'IT', label: 'Italian' }
];
